var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlusNetwork = function SvgPlusNetwork(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_2",
    viewBox: "0 0 216.49 185.36"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{stroke:#007533;fill:none;stroke-miterlimit:10;stroke-width:4px}.cls-2{stroke:#00db33}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M149.47 67.02c9.87-10.34 19.46-18.97 29.16-29.16M69 147.5a861 861 0 0 1 29.45-29.45M69.88 38.75l27.69 27.69M45.94 92.68h41.33M149.59 118.46l28.83 28.83",
    className: "cls-1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 193.51,
    cy: 22.98,
    r: 20.98,
    className: "cls-2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.98,
    cy: 92.68,
    r: 20.98,
    className: "cls-2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 54.11,
    cy: 22.98,
    r: 20.98,
    className: "cls-2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 193.51,
    cy: 161.03,
    r: 20.98,
    className: "cls-2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 123.81,
    cy: 92.68,
    r: 36.54,
    className: "cls-1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 54.11,
    cy: 162.38,
    r: 20.98,
    className: "cls-2"
  }))));
};
export default SvgPlusNetwork;